import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { SubContent } from "../../components/Layout";
import SideBarMenuGroup from "../SideBarMenuGroup";
import { toast } from "react-toastify";
import styleButton from "../Button/Button.module.css";
import api from "../../services/api";
import { ModalConfirm } from "../Modal";
import ProgressGroup from "../ProgressGroup";
import Accordion from "../Accordion";
import useWrapper from "../../hooks/useWrapper";
import useFormat from "../../hooks/utils/useFormat";
import StatusFlag from "../StatusFlag";
import Button from "../Button";
import ButtonLink from "../Button/ButtonLink";
import GroupRegisterProgress from "../GroupRegisterProgress";

export default function MenuGroup(props) {
  const { commercial, reload, setreload } = props;

  const { me, config } = useWrapper();
  const permissions = JSON.parse(me.permissions);

  const { stringToDate } = useFormat();

  const [showModalCancel, setshowModalCancel] = useState();
  const confirmCancel = async () => {
    try {
      await api.put(
        `commercial/${commercial.id}`,
        {
          active: 0,
        },
        config,
      );
    } catch (__error) {
      console.log("__error", __error);
      toast.error("Erro ao tentar cancelar a turma.");
    } finally {
      setshowModalCancel(false);
      setreload(!reload);
      toast.success("Turma cancelada com sucesso!");
    }
  };

  const [showModalReactivate, setshowModalReactivate] = useState();
  const confirmReactivate = async () => {
    try {
      await api.put(
        `commercial/${commercial.id}`,
        {
          active: 1,
        },
        config,
      );
    } catch (__error) {
      console.log("__error", __error);
      toast.error("Erro ao tentar reativar a turma.");
    } finally {
      setshowModalReactivate(false);
      setreload(!reload);
      toast.success("Turma reativada com sucesso!");
    }
  };

  const [showModalEnd, setshowModalEnd] = useState();
  const confirmEnd = async () => {
    try {
      await api.put(
        `commercial/${commercial.id}`,
        {
          status: "ended",
        },
        config,
      );
    } catch (__error) {
      console.log("__error", __error);
      toast.error("Erro ao tentar finalizar a turma.");
    } finally {
      setshowModalEnd(false);
      setreload(!reload);
      toast.success("Turma finalizada com sucesso!");
    }
  };

  const [progress, setprogress] = useState();
  useEffect(() => {
    if (commercial && commercial.first_event) {
      const _now = new Date();
      const _first_event = commercial.first_event;

      const _diff = Math.abs(_first_event.getTime() - _now.getTime());
      const _days = parseInt(_diff / (1000 * 3600 * 24));

      const _create = stringToDate(commercial.created_at);
      const _diffAll = Math.abs(_first_event.getTime() - _create.getTime());

      let _porcent;
      if (_days <= 0) {
        _porcent = 100;
      } else {
        _porcent = 100 - (_diff * 100) / _diffAll;
      }
      setprogress({
        width: _porcent,
        total_days: _days,
      });
    }
  }, [commercial, stringToDate]);

  return (
    <>
      <ModalConfirm
        show={showModalCancel}
        title="Cancelar Turma"
        text="Tem certeza que deseja cancelar esta Turma? Essa ação é reversível!"
        confirm={confirmCancel}
        closeModal={() => {
          setshowModalCancel(false);
        }}
        colorScheme="error"
        confirmText="Cancelar"
      />
      <ModalConfirm
        show={showModalReactivate}
        title="Reativar Turma"
        text="Tem certeza que deseja reativar esta Turma?"
        confirm={confirmReactivate}
        closeModal={() => {
          setshowModalReactivate(false);
        }}
        colorScheme="success"
      />
      <ModalConfirm
        show={showModalEnd}
        title="Finalizar Turma"
        text={
          <>
            <p>
              <b>Atenção!</b>
            </p>
            <p>Tem certeza que deseja finalizar esta Turma? Essa ação é irreversível!</p>
          </>
        }
        confirm={confirmEnd}
        closeModal={() => {
          setshowModalEnd(false);
        }}
        colorScheme="grey"
        confirmText="Finalizar"
      />

      {commercial && (
        <>
          <Row>
            <Col>
              <SubContent>
                <h2 class="mini-title mb-1">{commercial?.label}</h2>
                <GroupRegisterProgress registered={commercial?.trainees_active} expected={commercial?.total_trainees} />
                <p className="small-label m-0">
                  {commercial.packages_data.packages.length} Pacote{commercial.packages_data.packages.length > 1 && "s"}{" "}
                  e {commercial.packages_data.singles.length} Solenidade
                  {commercial.packages_data.singles.length > 1 && "s"} Avulsa
                  {commercial.packages_data.singles.length > 1 && "s"}
                </p>
                <p className="m-0">
                  <StatusFlag
                    status={commercial.status === "ended" ? "Finalizada" : commercial.active ? "Ativa" : "Cancelada"}
                  />
                  {!!commercial.legacy_id && <StatusFlag status={`Turma Legado - ${commercial.legacy_id}`} />}
                </p>
              </SubContent>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col>
              <SubContent className="p-0">
                <div className="bloco">
                  <SideBarMenuGroup commercialId={commercial.id} />
                </div>
              </SubContent>
            </Col>
          </Row>
          {!!commercial.code_access && (
            <Row className="mt-4">
              <Col>
                <SubContent>
                  <input type="text" value={`${window.location.origin}/cadastro/${commercial.code_access}`} />
                  <Button
                    onClick={() => {
                      navigator.clipboard.writeText(`${window.location.origin}/cadastro/${commercial.code_access}`);
                      toast.success("Convite Copiado!");
                    }}
                    colorScheme="primary"
                    className="w-100 mt-2"
                  >
                    Copiar Convite
                  </Button>
                </SubContent>
              </Col>
            </Row>
          )}
          {!!commercial?.whatsapp_link && (
            <Row className="mt-4">
              <Col>
                <SubContent>
                  <div className="bloco">
                    <ButtonLink to={commercial?.whatsapp_link} target="_blank" color="success" className="w-100 mt-2">
                      Grupo do Whatsapp
                    </ButtonLink>
                  </div>
                </SubContent>
              </Col>
            </Row>
          )}
          {progress && (
            <Row className="mt-4">
              <Col>
                <SubContent>
                  <div className="bloco mt-30">
                    <ProgressGroup progress={progress} />
                  </div>
                </SubContent>
              </Col>
            </Row>
          )}
          {permissions.commercial.update && (
            <>
              {(!!commercial.active || commercial.status !== "ended") && (
                <Row className="mt-4">
                  <Col>
                    <SubContent>
                      <Accordion>
                        <Accordion.Item eventKey="admin">
                          <Accordion.Header>
                            <div className="titleAccordion">
                              <span>Administrar Turma</span>
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                            <>
                              {!!commercial.active ? (
                                <button
                                  onClick={() => {
                                    setshowModalCancel(true);
                                  }}
                                  className={`${styleButton.button_error} w-100`}
                                >
                                  Cancelar Turma
                                </button>
                              ) : (
                                <button
                                  onClick={() => {
                                    setshowModalReactivate(true);
                                  }}
                                  className={`${styleButton.button_success} w-100`}
                                >
                                  Reativar Turma
                                </button>
                              )}
                              {commercial.status !== "ended" && (
                                <button
                                  onClick={() => {
                                    setshowModalEnd(true);
                                  }}
                                  className={`${styleButton.button_grey} w-100 mt-3`}
                                >
                                  Finalizar Turma
                                </button>
                              )}
                            </>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </SubContent>
                  </Col>
                </Row>
              )}
            </>
          )}
        </>
      )}
    </>
  );
}
